import { z } from "zod/v4";

import { GoogleGlobalSettingsDtoSchema } from "../../../../../dtos/google-integrations";
import { BaseIntegrationDtoSchema } from "../../../../../dtos/integrations";

export const PutGaIntegrationRequestBodySchema = z.object({
  globalSettings: GoogleGlobalSettingsDtoSchema,
});

export type PutGaIntegrationRequestBodyType = z.infer<
  typeof PutGaIntegrationRequestBodySchema
>;

export const PutGaIntegrationResponseBodySchema = z.object({
  integration: BaseIntegrationDtoSchema,
});
export type PutGaIntegrationResponseBodyType = z.infer<
  typeof PutGaIntegrationResponseBodySchema
>;
